import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
  standalone: true
})
export class TimeAgoPipe implements PipeTransform {

  transform(value: string): string {
    const date = new Date(value);
    const now = new Date();
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    let interval = Math.floor(seconds / 31536000);
    if (interval > 1) return `pre ${interval} godina`;
    if (interval === 1) return `pre godinu dana`;

    interval = Math.floor(seconds / 2592000);
    if (interval > 1) return `pre ${interval} meseci`;
    if (interval === 1) return `pre mesec dana`;

    interval = Math.floor(seconds / 86400);
    if (interval > 1) return `pre ${interval} dana`;
    if (interval === 1) return `pre 1 dan`;

    interval = Math.floor(seconds / 3600);
    if (interval > 1) return `pre ${interval} sati`;
    if (interval === 1) return `pre 1 sat`;

    interval = Math.floor(seconds / 60);
    if (interval > 1) return `pre ${interval} minuta`;
    if (interval === 1) return `pre 1 minut`;

    return seconds === 1 ? `pre 1 sekund` : `pre ${seconds} sekundi`;
  }


}
